import { IIconBase } from '..'

const inativarIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 128.000000 128.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,128.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M500 1265 c-212 -46 -402 -221 -473 -438 -29 -88 -29 -286 0 -374 88
        -268 338 -453 613 -453 275 0 525 185 613 453 29 88 29 286 0 374 -89 271
        -340 454 -618 452 -38 0 -99 -7 -135 -14z m220 -136 c54 -8 170 -50 170 -61 0
        -2 -153 -156 -340 -343 l-339 -339 -25 55 c-127 277 46 619 347 684 78 17 106
        17 187 4z m379 -298 c11 -27 26 -83 32 -125 47 -318 -239 -604 -557 -557 -71
        10 -174 46 -174 60 0 8 663 671 671 671 4 0 16 -22 28 -49z'
        />
      </g>
    </svg>
  )
}

export default inativarIcon
